module.exports = __webpack_public_path__ + "static/media/warning.02e6d0dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/documentList/warning.svg
// module id = 2206
// module chunks = 0